// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3y-V7","inner":"Footer_inner__2UmD0"};